import { IMAGE_RESIZE_SPEC } from '@core/image'
import { Cover, Skeleton } from '@ds/components'

import styles from './AudioCardSkeleton.module.css'

export const AudioCardSkeleton = () => (
    <div className={styles.card} data-test="audio-card-skeleton">
        <div className={styles.coverBox}>
            <Cover
                src=""
                alt=""
                sizes="(max-width: 767px) 56px, 140px"
                className={styles.coverImage}
                resize={IMAGE_RESIZE_SPEC}
            />
        </div>
        <div className={styles.main}>
            <Skeleton className={styles.title} />
            <Skeleton className={styles.author} />
            <Skeleton className={styles.body} />
        </div>
    </div>
)
